export default __webpack_public_path__ + "images/66d50ee39b02052ac00b530a45559c8e-loader-purple.png";